import React, { useEffect } from 'react';

const ComparisonTableTemplateWidget = ({ selectedLayout, isTemplateId, widgetId, pricingTableTabData }) => {
    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/pricing-table/temp-css/PricingTableWidget.css`;
        if (widgetId) {
            link.setAttribute("pricing-table-data-dynamic-css", "pricing-table");
        } else {
            link.setAttribute("data-dynamic-css", "pricing-table");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="pricing-table"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);
    
    return (
        <>
            <div className={`upgadeify pricing-table-comparison-table-temp ${pricingTableTabData.is_website_frontend}`}>
                <div className="comparison-table">
                    <div className="comparison_table_image comparison_header_row">
                        <div className="cell"></div>
                        <div className="cell"><img src="/pricing-table/templates/tesla_model_s.png" alt="Tesla Model S" /></div>
                        <div className="cell"><img src="/pricing-table/templates/tesla_model_X.png" alt="Tesla Model X" /></div>
                        <div className="cell"><img src="/pricing-table/templates/tesla_model_3.png" alt="Tesla Model 3" /></div>
                    </div>
                    <div className="comparison_header_row">
                        <div className="cell"></div>
                        <div className="cell"><h2>Tesla Model S</h2></div>
                        <div className="cell"><h2>Tesla Model X</h2></div>
                        <div className="cell"><h2>Tesla Model 3</h2></div>
                    </div>

                    <div className="row"><div className="label">Battery</div><div className="cell">75–100 kWh</div><div className="cell">75–100 kWh</div><div className="cell">75–100 kWh</div></div>
                    <div className="row"><div className="label">Range</div><div className="cell">259–315 Miles</div><div className="cell">237–289 Miles</div><div className="cell">215–310 Miles</div></div>
                    <div className="row"><div className="label">Acceleration</div><div className="cell">2.5–4.2 Sec (0–60 Mph)</div><div className="cell">2.9–4.9 Sec (0–60 Mph)</div><div className="cell">3.5–5.6 Sec (0–60 Mph)</div></div>
                    <div className="row"><div className="label">Weight</div><div className="cell">4,769–4,941 Lbs</div><div className="cell">5,307–5,531 Lbs</div><div className="cell">3,552–4,072 Lbs</div></div>
                    <div className="row"><div className="label">Cargo</div><div className="cell">30 Cu Ft</div><div className="cell">88 Cu Ft</div><div className="cell">15 Cu Ft</div></div>
                    <div className="row"><div className="label">Displays</div><div className="cell">Driver Display + 17" Touchscreen</div><div className="cell">Driver Display + 17" Touchscreen</div><div className="cell">15" Center Touchscreen</div></div>
                    <div className="row"><div className="label">Drive</div><div className="cell">All-Wheel Drive</div><div className="cell">All-Wheel Drive</div><div className="cell">Rear-Wheel Drive or Dual Motor All-Wheel Drive</div></div>
                    <div className="row"><div className="label">Supercharging</div><div className="cell">Free Unlimited Supercharging</div><div className="cell">Free Unlimited Supercharging</div><div className="cell">Pay Per Use</div></div>
                    <div className="row"><div className="label">Seating</div><div className="cell">5 Adults + 2 Child Seats</div><div className="cell">Up To 7 Adults</div><div className="cell">5 Adults</div></div>
                    <div className="row"><div className="label">Wheels</div><div className="cell">19" or 21"</div><div className="cell">20" or 22"</div><div className="cell">18", 19" or 20"</div></div>
                    <div className="row"><div className="label">Warranty</div><div className="cell">4 Years, Basic Vehicle 8 Years, Battery & Powertrain</div><div className="cell">4 Years, Basic Vehicle 8 Years, Battery & Powertrain</div><div className="cell">4 Year 50,000 & Year 120,000</div></div>

                    <div className="footer-row">
                        <div className="cell"></div>
                        <div className="cell price"><strong>$77,000</strong><p>Starting MSRP</p><button>Order Now</button></div>
                        <div className="cell price"><strong>$83,000</strong><p>Starting MSRP</p><button>Order Now</button></div>
                        <div className="cell price"><strong>$49,000</strong><p>Starting MSRP</p><button>Order Now</button></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ComparisonTableTemplateWidget;
